import { CardContent, Grid, Typography, Stack } from '@mui/material'
import {
  useTranslate,
  useShowContext,
  // BooleanField,
} from 'react-admin'
import { ShowBase } from '../../components/base'
import { CONTACT_US_FIELDS } from '../../providers/localization/constant'
import {
  ContentWrapper,
  Heading,
  TextFieldStyled,
  EmailFieldStyled,
  DateFieldStyled,
} from '../../components/domains/contact_us'

const ContactUsDetail = (): JSX.Element => {
  const { record, error, isLoading } = useShowContext()
  const translate = useTranslate()
  return (
    <Grid container spacing={3} sx={{ padding: '16px 16px 0' }}>
      {!isLoading && (
        <>
          <Grid item xs={12} md={12}>
            <Stack spacing={1}>
              <Typography variant='h4' sx={{ color: '#000000' }}>
                {record.subject} 
              </Typography>
            </Stack>
          </Grid>
          <Grid item sm={12}>
            <Stack spacing={2}>
              {/* <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.subject`)}</Heading>
                  <TextFieldStyled source='subject' emptyText='-' />
                </ContentWrapper>
              </Grid> */}
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.message`)}</Heading>
                  <TextFieldStyled source='message' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.create_at`)}</Heading>
                  <DateFieldStyled source='create_at' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.full_name`)}</Heading>
                  <TextFieldStyled source='full_name' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.email`)}</Heading>
                  <EmailFieldStyled source='email' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.phone`)}</Heading>
                  <TextFieldStyled source='phone' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.line_id`)}</Heading>
                  <TextFieldStyled source='line_id' emptyText='-' />
                </ContentWrapper>
              </Grid>
              {/* <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${CONTACT_US_FIELDS}.accept`)}</Heading>
                  <BooleanField
                    source='is_accept'
                    label={`${CONTACT_US_FIELDS}.is_accept`}
                  />
                </ContentWrapper>
              </Grid> */}
              
            </Stack>
          </Grid>
        </>
      )}
      {isLoading && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Loading...</Typography>
          </Grid>
        </Grid>
      )}
      {error && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Error cannot load resource, please contact admin</Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

const ContactUsShow = (): JSX.Element => {
  return (
    <ShowBase
      title='resources.contact_us.show.title'
      listAction={{ hasEdit: false, hasBackButton: true }}
    >
      <>
        <CardContent>
          <ContactUsDetail />
        </CardContent>
      </>
    </ShowBase>
  )
}

export default ContactUsShow
